import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CommonLibModule } from '@common/common-lib.module';
import { AppComponent } from './app.component';
import { AuthComponent } from '@auth/auth.component';
import { AuthService } from '@auth/auth.service';
import { AuthInterceptor } from '@auth/auth.interceptor';
import { AuthApiService } from '@auth/auth.api.service';
import { AuthSsoComponent } from '@auth/auth-sso/auth-sso.component';
import { AppRoutes } from './app.routes';
import { ErrorScreenComponent } from './error-screen/error-screen.component';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '@env/environment';
import { metaReducers, reducers } from '@common/reducers';
import { EffectsModule } from '@ngrx/effects';
import { TokenService } from '@common/services/utility/token.service';
import { ConfigService } from '@common/services/config/config.service';
import { BrowserNotificationService } from '@common/services/browser-notification/browser-notification.service';
import { StatusComponent } from './status/status.component';
import { PingComponent } from './ping/ping.component';
import { VersionComponent } from './version/version.component';
import { IConfigResponse } from '@common/services/config/data/config-response.interface';
import { RedirectService } from '@common/services/redirect/redirect.service';
import { SessionCallRedirectComponent } from './session-call-redirect/session-call-redirect.component';
import { NetworkErrorInterceptor } from '@common/interceptors/network-error';

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    ErrorScreenComponent,
    StatusComponent,
    PingComponent,
    VersionComponent,
    SessionCallRedirectComponent,
    AuthSsoComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    CommonLibModule,
    AppRoutes,
    StoreModule.forRoot(reducers, {
      metaReducers,
    }),
    EffectsModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
  ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigService) => (): Promise<IConfigResponse> => configService.load(),
      deps: [ConfigService],
      multi: true,
    },
    AuthService,
    AuthApiService,
    TokenService,
    RedirectService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkErrorInterceptor,
      multi: true,
    },
    BrowserNotificationService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
